<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">绑定科目</span>
            </template>
            <template #left>
                <router-link to="/">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/"><van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/></router-link>
            </template>
        </van-nav-bar>


        <van-cell-group title="当前选择">
            <van-cell :title="choose_test">
                <template #right-icon>
                    <van-button v-if="chooses.length>0" @click="toBack" size="mini" type="default">返回</van-button>
                </template>
            </van-cell>

        </van-cell-group>

        <van-cell-group title="科目">


            <van-list v-model="loading"
                      :finished="finished"
                      :error.sync="error"
                      :error-text="error_text"
                      finished-text=""
                      @load="onLoad">
                <van-cell v-for="(item,index) in list" is-link @click="chooseItem(item.id,index)" :key="item.id"
                          :title="item.name"/>
            </van-list>


        </van-cell-group>
        <br>


    </div>
</template>
<script>
    export default {
        data() {
            return {
                loading: false,
                finished: false,
                error: false,
                error_text: "",

                chooses: [],
                choose_test: "",

                pid: 0,
                list: [],
            }
        },
        created() {
        },
        methods: {
            onLoad() {
                this.list = [];
                this.loading = true;
                this.$http.get("/common/subjects", {params: {pid: this.pid}}).then(res => {
                    console.log(res.data);
                    this.loading = false;
                    this.finished = true;
                    if (200 !== res.data.code) {
                        this.error = true
                        this.error_text = res.data.msg
                        return
                    }
                    if (res.data.data.length <= 0) {
                        //最终的选项了

                        console.log(this.chooses)
                        this.$http.get("/wechat/user/binding/subject",{
                            params:{
                                root_id:this.chooses[0].id,
                                last_id:this.pid
                            }
                        }).then(res => {
                            console.log(res.data);
                            if (200 !== res.data.code) {
                                //
                            }
                            this.$router.push('/');


                        });

                        return
                    }
                    this.list = res.data.data;

                });
            },
            toBack() {
                if (this.chooses.length <= 0) {
                    return
                }
                let item = this.chooses.pop();
                this.pid = item.pid;
                this.updateChoose();
                this.onLoad();
            },
            chooseItem(id, index) {
                this.pid = id
                this.chooses.push(this.list[index])
                this.updateChoose()
                this.onLoad()
            },

            updateChoose() {
                this.choose_test = ""
                this.chooses.forEach((item) => {
                    if (0 === item.pid) {
                        this.choose_test += item.name
                    } else {
                        this.choose_test += "->" + item.name

                    }
                })
            }
        }

    }
</script>
